/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "common": {
        "nested": {
          "calendar": {
            "nested": {
              "CalendarEvent": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "startDatetime": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "stopDatetime": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "timeZone": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "recurrenceInfo": {
                    "type": "squareup.common.calendar.CalendarEvent.Recurrence",
                    "id": 5,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Recurrence": {
                    "fields": {
                      "rrule": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "exdate": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.common?.nested?.calendar?.nested?.CalendarEvent && !$root.nested?.squareup?.nested?.common?.nested?.calendar?.nested?.CalendarEvent?.nested?.Recurrence) {
  $root.addJSON(jsonData);
}

/**
 * An event that can be represented on a calendar, with optional repeating rules. Materialized instances
 * are modeled as CalendarOccurrence objects.
 *
 * A CalendarEvent without a repeating rules (rrules) are assumed to contain one CalendarOccurrence.
 * With rrules, 0 to infinite occurrences.
 *
 * Timestamp should include timezone offset, to disambiguate possible daylight savings offsets
 *
 * See go/time-primitives for more details
 *
 * SOURCE CalendarEvent @ squareup/common/calendar/calendar.proto at 19:1
 */
export const CalendarEvent = $root.lookupType('squareup.common.calendar.CalendarEvent');
fixType(CalendarEvent, {
  startDatetime: {
    notEmpty: true
  },
  stopDatetime: {
    notEmpty: true
  },
  timeZone: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CalendarEvent);
/**
 * SOURCE Recurrence @ squareup/common/calendar/calendar.proto at 39:3
 */
CalendarEvent.Recurrence = $root.lookupType('squareup.common.calendar.CalendarEvent.Recurrence');
fixType(CalendarEvent.Recurrence, {
  rrule: {
    notEmpty: true
  }
});
Builder.createAndAttachToType(CalendarEvent.Recurrence);